<template>
  <key-unit class="editor-info-editable-item" :title="title">
    <template v-slot:content>
      <div>
        <el-date-picker
          :append-to-body="false"
          v-model="value"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </template>
  </key-unit>
</template>
  
  <script>
import KeyUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit.vue";
export default {
  components: {
    KeyUnit,
  },

  model: {
    prop: "inputValue",
    event: "onChanged",
  },

  props: {
    title: String,
    inputValue: Date,
    pickerOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      value: undefined,
    };
  },

  created() {
    this.value = this.inputValue;
  },

  watch: {
    inputValue(value) {
      this.value = value;
    },

    value(value) {
      this.$emit("onChanged", value);
    },
  },
};
</script>
  